import { weekDays } from "../../constants/variables";

const capitalise = day => day[0].toUpperCase() + day.slice(1);

// The days Check for conflicts should look at: the days that are actually on
// the schedule, by the same rule the day tabs use (a day with a start or end
// time). Removing a day only clears its hours; its classes are still saved, so
// asking for every key of boardDays used to surface warnings for classes on a
// day the studio had deleted and could no longer see or fix.
//
// boardDays also carries id and boardId, which were being sent as "Id" and
// "BoardId" days. Only real weekdays are returned, in week order.
export const conflictCheckDays = (boardDays, weekday) => {
    if (boardDays) {
        return weekDays
            .filter(day => boardDays[day] && (boardDays[day].start || boardDays[day].end))
            .map(capitalise);
    }
    return weekday ? [capitalise(weekday)] : [];
};
